export default "__VITE_ASSET__2b1ef7ed__"